<template>
	<transition name="rsb-fade">
		<div v-if="stale" class="rsb" role="status" aria-live="polite">
			<span class="rsb-dot" aria-hidden="true"></span>
			<p class="rsb-text">
				<strong>Estamos actualizando el reporte con tus últimos cambios.</strong>
				Mientras tanto ves la versión anterior; en uno o dos minutos estará al día.
			</p>
			<button type="button" class="rsb-action" @click="refresh">Actualizar</button>
		</div>
	</transition>
</template>

<script>
import {
	REPORT_SOURCE_STALE,
	clearReportMemo,
	subscribeReportSource,
} from "@/api/financialReport";

// Banner "Actualizando…" del Reporte Financiero (etapa 2 de
// docs/DECISIONES.md §19). Se enciende cuando CUALQUIER
// respuesta del tab activo llegó con X-Report-Source: stale (la empresa está en
// modo precalculado y su tabla de hechos tiene un recálculo pendiente) y se
// apaga al cambiar de tab (`resetKey`) o al pedir "Actualizar", que vacía el
// memo y remonta el tab para que refetchee. Un tab hace varios requests: gana
// el peor caso (un solo dato viejo hace vieja a la vista).
export default {
	name: "ReportStaleBanner",
	props: {
		// Cambiarla apaga el banner: el tab nuevo decide con sus propias respuestas.
		resetKey: { type: [String, Number], default: "" },
	},
	data() {
		return { stale: false };
	},
	watch: {
		resetKey() {
			this.stale = false;
		},
	},
	created() {
		// Propiedad de instancia no reactiva: la suscripción no es estado de UI.
		this.unsubscribeSource = subscribeReportSource(this.onReportSource);
	},
	beforeDestroy() {
		if (this.unsubscribeSource) this.unsubscribeSource();
	},
	methods: {
		onReportSource(source) {
			if (source === REPORT_SOURCE_STALE) this.stale = true;
		},
		refresh() {
			clearReportMemo();
			this.stale = false;
			this.$emit("refresh");
		},
	},
};
</script>

<style lang="scss" scoped>
.rsb {
	display: flex;
	align-items: center;
	gap: 12px;
	margin: 0 0 16px;
	padding: 10px 14px;
	border: 1px solid var(--report-highlight-border);
	border-radius: 8px;
	background: var(--report-highlight-bg);
	color: var(--report-text);
	font-size: 13px;
	line-height: 1.4;
}

.rsb-dot {
	flex: 0 0 auto;
	width: 8px;
	height: 8px;
	border-radius: 50%;
	background: var(--report-highlight-border);
	animation: rsb-pulse 1.6s ease-in-out infinite;
}

.rsb-text {
	flex: 1 1 auto;
	margin: 0;

	strong {
		color: var(--report-text);
		margin-right: 4px;
	}
}

.rsb-action {
	flex: 0 0 auto;
	padding: 4px 12px;
	border: 1px solid var(--report-highlight-border);
	border-radius: 6px;
	background: transparent;
	color: var(--report-text-strong-2);
	font: inherit;
	font-weight: 600;
	cursor: pointer;

	&:hover {
		background: var(--report-highlight-border);
	}
}

@keyframes rsb-pulse {
	0%, 100% { opacity: 1; }
	50% { opacity: 0.35; }
}

.rsb-fade-enter-active,
.rsb-fade-leave-active {
	transition: opacity 0.2s ease;
}

.rsb-fade-enter,
.rsb-fade-leave-to {
	opacity: 0;
}
</style>
